import LegalPage from "@/components/LegalPage";

const sections = [
  {
    h: "Who we are",
    paras: [
      "KC Consultancy is a specialist Youth Justice consultancy working with local authorities and partner organisations across England and Wales.",
      "KC Consultancy is the trading name of Kathleen Cullen Care Limited.",
      "For the purposes of the UK General Data Protection Regulation (UK GDPR) and the Data Protection Act 2018, Kathleen Cullen Care Limited is the data controller for personal information collected through this website. You can contact us about any data protection matter at info@kcconsultancy.co.uk.",
    ],
  },
  {
    h: "Data protection commitment",
    paras: [
      "KC Consultancy is committed to protecting personal information and handling data securely. We take our data protection and confidentiality responsibilities seriously.",
    ],
  },
  {
    h: "What information we collect",
    paras: [
      "When you submit our enquiry form we collect your name, organisation, email address, the service you are interested in, and the content of your message.",
      "We do not collect special category (sensitive) personal data through this website, and we ask that you do not include sensitive personal information about yourself or others in your message.",
    ],
  },
  {
    h: "How we use your information",
    paras: [
      "We use the information you provide to respond to your enquiry, manage our correspondence with you, and — where relevant — arrange an initial conversation about a potential commission.",
      "Our lawful basis for this processing is our legitimate interest in responding to business enquiries and, where discussions progress, taking steps prior to entering into a contract.",
    ],
  },
  {
    h: "How we store and protect your information",
    paras: [
      "Enquiry details are stored securely and notification emails are delivered through our email processing provider. Access to enquiry information is limited to KC Consultancy.",
      "We apply appropriate technical and organisational measures to protect personal information against unauthorised access, loss or disclosure.",
    ],
  },
  {
    h: "Who we share your information with",
    paras: [
      "We never sell or rent personal information. We share information only with the service providers who operate this website and our email delivery, who process it on our behalf under appropriate safeguards, or where we are required to do so by law.",
    ],
  },
  {
    h: "How long we keep your information",
    paras: [
      "We keep personal information no longer than necessary. Enquiries that do not lead to a working relationship are normally deleted within 24 months of our last correspondence.",
    ],
  },
  {
    h: "Your rights",
    paras: [
      "Under data protection law you have the right to access the personal information we hold about you, and to ask for it to be corrected, erased, restricted or transferred. You also have the right to object to our processing.",
      "To exercise any of these rights, contact us at info@kcconsultancy.co.uk. We will respond within one month.",
    ],
  },
  {
    h: "Cookies",
    paras: [
      "This website uses only strictly necessary cookies. Please see our Cookie Policy for details.",
    ],
  },
  {
    h: "ICO registration and complaints",
    paras: [
      "KC Consultancy is registered with the Information Commissioner's Office (ICO), registration reference C2040968.",
      "If you are unhappy with how we have handled your personal information, please contact us first so we can try to resolve the matter.",
      "You also have the right to complain to the ICO at ico.org.uk or by calling 0303 123 1113.",
    ],
  },
  {
    h: "Changes to this policy",
    paras: [
      "We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.",
    ],
  },
];

export default function Privacy() {
  return (
    <LegalPage
      title="Privacy Policy"
      updated="July 2026"
      sections={sections}
      testid="privacy-page"
    />
  );
}
